<template>
  <div
    class="element-editor"
    :class="{'default-image': isPlaceholderImage}"
    :id="blockId"
    :style="blockStyle"
  >
    <img
      class="image-editor w-full h-full absolute top-0 left-0"
      :class="[animateClass , {'custom-opacity-0': !imageLoaded} ,
      ]"
      :src="src"
      @load="onImageLoad"
    >
    <div
      class="spinner-wrapper"
      :class="`spinner-wrapper--${theme}`"
      v-if="!isPlaceholderImage && !imageLoaded"
    >
      <aha-spinner :variant="theme" size="xl" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import EventBus from '@/eventBus'
import utils from '@/util'

export default {
  name: 'ImageEditor',
  props: {
    src: {
      type: [String, Object],
      default: null,
    },
    isPlaceholderImage: {
      type: Boolean,
      default: false,
    },
    blockId: {
      type: String,
      default: null,
    },
    blockStyle: {
      type: Object,
      default: null,
    },
    preview: {
      type: Boolean,
      default: false,
    },
    animation: {
      type: String,
      default: null,
    },
    isInfinity: {
      type: Boolean,
      default: false,
    },
    duration: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      imageLoaded: false,
    }
  },
  computed: {
    ...mapGetters({
      slideActive: 'activeActivity',
    }),
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    animateClass() {
      return utils.animateClass({
        animation: this.animation,
        isInfinity: this.isInfinity,
        duration: this.duration,
      })
    },
    theme() {
      return this.slideActive.textColour === '#ffffff' ? 'white' : 'dark'
    },

    imagePlaceholderVisible() {
      return !this.preview
    },
  },

  watch: {
    src: function watchSrc(oldSrc, newSrc) {
      if (oldSrc !== newSrc) {
        this.imageLoaded = false
      }
    },
  },

  mounted() {
    this.$nextTick(() => { this.$emit('ready') })
  },

  destroyed() {
    this.imageLoaded = false
  },

  methods: {
    onImageLoad() {
      this.imageLoaded = true
    },
    openUploadImageModal() {
      EventBus.$emit('open-image-upload-modal', this.blockId)
    },
    onClickOutside() {
      this.$emit('onBlur')
    },
  },
}
</script>

<style lang="scss" scoped>
.spinner-wrapper {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
}

.spinner-wrapper--dark {
  background: rgba(0, 0, 0, 0.05);

}
.spinner-wrapper--white {
  background: rgba(255, 255, 255, 0.1);

}

.image-editor {
  width: 100%;
  height: 100%;
}
</style>
